import dynamic from 'next/dynamic';
import type { Step } from '../flows';
export const inFlow: Step[] = [{
  step: 'summary',
  screenViewEvent: {
    name: 'fix_summary'
  },
  Component: dynamic(() => import('../../Summary/Summary').then(module => module.Summary), {
    ssr: false
  }),
  hideNav: true
}, {
  step: 'payment',
  screenViewEvent: {
    name: 'consolidated_shipping_payment'
  },
  gutter: 'narrow',
  Component: dynamic(() => import('../../ShippingPaymentConsolidated/ShippingPaymentConsolidated').then(module => module.ShippingPaymentConsolidated), {
    ssr: false
  }),
  showNavTitle: true
}, {
  step: 'finalize',
  screenViewEvent: {
    name: 'confirm_first_fix'
  },
  Component: dynamic(() => import('../../Finalize/Finalize').then(module => module.Finalize), {
    ssr: false
  }),
  hideNav: true,
  bgColor: 'mint',
  navBgColor: 'mint'
}];